export enum ApiScope {
  // Campaign Management
  CAMPAIGN_READ = 'campaign:read',
  CAMPAIGN_WRITE = 'campaign:write',
  CAMPAIGN_DELETE = 'campaign:delete',

  // Order Management
  ORDER_READ = 'order:read',
  ORDER_WRITE = 'order:write',
  ORDER_DELETE = 'order:delete',

  // Creative Management
  CREATIVE_READ = 'creative:read',
  CREATIVE_WRITE = 'creative:write',
  CREATIVE_DELETE = 'creative:delete',

  // Placement Management
  PLACEMENT_READ = 'placement:read',
  PLACEMENT_WRITE = 'placement:write',
  PLACEMENT_DELETE = 'placement:delete',

  // Publisher Management
  PUBLISHER_READ = 'publisher:read',
  PUBLISHER_WRITE = 'publisher:write',
  PUBLISHER_DELETE = 'publisher:delete',

  // Site Management
  SITE_READ = 'site:read',
  SITE_WRITE = 'site:write',
  SITE_DELETE = 'site:delete',

  // Advertiser Management
  ADVERTISER_READ = 'advertiser:read',
  ADVERTISER_WRITE = 'advertiser:write',
  ADVERTISER_DELETE = 'advertiser:delete',

  // Agency Management
  AGENCY_READ = 'agency:read',
  AGENCY_WRITE = 'agency:write',
  AGENCY_DELETE = 'agency:delete',

  // Reporting & Analytics
  REPORT_READ = 'report:read',
  REPORT_EXPORT = 'report:export',
  DASHBOARD_READ = 'dashboard:read',

  // Revenue Data (Sensitive)
  REVENUE_READ = 'revenue:read',
  BILLING_READ = 'billing:read',

  // Tag Management
  TAG_READ = 'tag:read',
  TAG_WRITE = 'tag:write',
  TAG_DELETE = 'tag:delete',

  // User Management
  USER_READ = 'user:read',
  USER_WRITE = 'user:write',
  USER_DELETE = 'user:delete',

  // Ad Network Management
  ADNETWORK_READ = 'adnetwork:read',
  ADNETWORK_WRITE = 'adnetwork:write',
  ADNETWORK_DELETE = 'adnetwork:delete',

  // API Key Management
  APIKEY_READ = 'apikey:read',
  APIKEY_WRITE = 'apikey:write',
  APIKEY_DELETE = 'apikey:delete',

  // Audit Logs
  AUDIT_READ = 'audit:read',

  // System Operations
  SYSTEM_READ = 'system:read',
  SYSTEM_WRITE = 'system:write',

  // User Impersonation
  USER_IMPERSONATE = 'user:impersonate',

  // Full Access
  ALL = '*',
}
